const sortProductsByOdd = (a, b) => {
  let aScore, bScore
  const score = {
    excellent: 2,
    good: 3,
    fair: 4,
    poor: 5,
    none: 6
  }

  aScore = a.odd || 'none'
  bScore = b.odd || 'none'

  aScore = score[aScore] || 6
  bScore = score[bScore] || 6

  if (window.Alpine.store(a.key).isAoOffer) {
    aScore = 1
  }

  if (window.Alpine.store(b.key).isAoOffer) {
    bScore = 1
  }

  return aScore - bScore
}

module.exports = sortProductsByOdd
